import { Component, EventEmitter, OnInit, Output, OnDestroy } from '@angular/core';
import { CompanyService } from '@s-services/company.service';
import { BookingProfileService } from '@s-services/booking-profile.service';
import { AuthService } from '@s-services/auth.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { User } from '@semmily/types';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@s-app/material.module';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-list-booking-profiles',
    templateUrl: './list-booking-profiles.component.html',
    styleUrls: ['./list-booking-profiles.component.scss'],
    imports: [
        CommonModule,
        MaterialModule,
        FormsModule
    ]
})
export class ListBookingProfilesComponent implements OnInit, OnDestroy {
  @Output() handleBpClick = new EventEmitter();

  private destroy$ = new Subject<void>();
  bookingProfilesInCalendar: string[] = [];

  constructor(
    public companyService: CompanyService,
    public bookingProfileService: BookingProfileService,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.authService.user.pipe(takeUntil(this.destroy$)).subscribe((user: User | null) => {
      this.bookingProfilesInCalendar = user?.bookingProfilesInCalendar || [];
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  isBookingProfileChecked(bpId: string) {
    return this.bookingProfilesInCalendar ? this.bookingProfilesInCalendar.indexOf(bpId) >= 0 : false;
  }

}
